import { Consent } from '@axo/form/feature/axo-form-v2/lib/components';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { SwitchFieldUI } from '@axo/form/feature/form-input/SwitchField/SwitchFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useFormContext } from 'react-hook-form';
import type { Step8Data } from '../../FormData.dk.types';
import { radioOptions } from '../../config/globals';
import { requiredField } from '../shared-config';
import { CoApplicantCitizenFormGroup } from './CoApplicantCitizenFormGroup';
import { CoApplicantEmploymentFormGroup } from './CoApplicantEmploymentFormGroup';
import { CoApplicantPersonFormGroup } from './CoApplicantPersonFormGroup';

export function CoApplicantFormGroup() {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const addCoApplicant = watch('Frontend/AddCoApplicant');

  return (
    <>
      <SwitchFieldUI<Step8Data>
        name="Frontend/AddCoApplicant"
        label={t('AddCoApplicant.label')}
        description={t('AddCoApplicant.description')}
        data-testid="add-co-applicant-switch"
      />

      {addCoApplicant && (
        <>
          <CoApplicantPersonFormGroup />

          <CoApplicantEmploymentFormGroup />

          <CoApplicantCitizenFormGroup />

          <RadioFieldUI<Step8Data>
            name="LoanApplication/CoApplicantHasUnemploymentFund"
            label={t('HasUnemploymentFund.label', { context: 'coapp' })}
            data-testid="has-unemployment-fund-radio"
            radioStyle="both"
            options={radioOptions}
            registerOptions={requiredField}
          />

          <Consent>
            <Consent.Marketing applicant="coapp" />
            <Consent.TermsAndConditions />
          </Consent>
        </>
      )}
    </>
  );
}
